import React, { FC, KeyboardEvent } from "react";
import "./textField.css";
import { FieldError } from "react-hook-form";

interface TextFieldProps {
  id?: string;
  onChange?: (id: string, value: string) => void;
  defaultValue?: string;
  placeholder?: string;
  type?: string;
  value?: string;
  className?: string;
  register?: unknown;
  min?: string;
  errors?: FieldError | undefined;
  onKeyPress?: (event: KeyboardEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  readOnly?: boolean;
}

const TextField: FC<TextFieldProps> = ({
  id,
  onChange,
  defaultValue,
  placeholder,
  type,
  value,
  className,
  min,
  errors,
  onKeyPress,
  disabled,
  readOnly,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    onChange?.(id as string, inputValue);
  };

  return (
    <>
      <input
        id={id}
        type={type}
        value={value ?? defaultValue}
        onChange={handleChange}
        className={
          type == "password" || type == "email"
            ? `${className}`
            : `inputStyle ${className}`
        }
        placeholder={placeholder}
        min={min}
        onKeyDown={onKeyPress}
        disabled={disabled}
        readOnly={readOnly}
      />
      {errors?.message && (
        <p className="text-red-500 text-xs font-semibold">{errors.message}</p>
      )}
    </>
  );
};

export default TextField;
